import { render } from "./CorporatePlanSuccessReload.vue?vue&type=template&id=8b330ef4"
import script from "./CorporatePlanSuccessReload.vue?vue&type=script&lang=js"
export * from "./CorporatePlanSuccessReload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__